export const REMOVE_AFTER_SELECTION_MODE = {
  TODAY: "today",
  UNTIL_REFRESH: "untilRefresh",
};

export const DEFAULT_REMOVE_AFTER_SELECTION_MODE = REMOVE_AFTER_SELECTION_MODE.TODAY;

export const getUseRemoveNamesStorageKey = (classId) => `useRemoveNames-${classId}`;
export const getNamesToRemoveListStorageKey = (classId) => `namesToRemoveList-${classId}`;
export const getRemoveAfterSelectionModeStorageKey = (classId) =>
  `removeAfterSelectionMode-${classId}`;

export const getTodayDateString = (now = new Date()) => now.toDateString();

const getStorage = () => {
  if (typeof window === "undefined" || !window.localStorage) return null;
  return window.localStorage;
};

export const isRemoveAfterSelectionMode = (value) =>
  value === REMOVE_AFTER_SELECTION_MODE.TODAY
  || value === REMOVE_AFTER_SELECTION_MODE.UNTIL_REFRESH;

export const readUseRemoveNamesEnabled = (classId) => {
  if (!classId) return false;
  const storage = getStorage();
  if (!storage) return false;
  return storage.getItem(getUseRemoveNamesStorageKey(classId)) === "true";
};

export const writeUseRemoveNamesEnabled = (classId, enabled) => {
  if (!classId) return;
  const storage = getStorage();
  if (!storage) return;
  storage.setItem(getUseRemoveNamesStorageKey(classId), JSON.stringify(Boolean(enabled)));
};

export const readRemoveAfterSelectionMode = (classId) => {
  if (!classId) return DEFAULT_REMOVE_AFTER_SELECTION_MODE;
  const storage = getStorage();
  if (!storage) return DEFAULT_REMOVE_AFTER_SELECTION_MODE;
  const stored = storage.getItem(getRemoveAfterSelectionModeStorageKey(classId));
  return isRemoveAfterSelectionMode(stored) ? stored : DEFAULT_REMOVE_AFTER_SELECTION_MODE;
};

export const writeRemoveAfterSelectionMode = (classId, mode) => {
  if (!classId) return;
  const storage = getStorage();
  if (!storage) return;
  const nextMode = isRemoveAfterSelectionMode(mode)
    ? mode
    : DEFAULT_REMOVE_AFTER_SELECTION_MODE;
  storage.setItem(getRemoveAfterSelectionModeStorageKey(classId), nextMode);
};

const parseStoredNamesToRemoveList = (rawValue, { expireAtMidnight, today }) => {
  if (!rawValue) return [];
  try {
    const parsed = JSON.parse(rawValue);
    if (Array.isArray(parsed)) {
      return parsed;
    }
    if (parsed && Array.isArray(parsed.names)) {
      if (expireAtMidnight && parsed.date && parsed.date !== today) {
        return [];
      }
      return parsed.names;
    }
  } catch {
    return [];
  }
  return [];
};

export const readNamesToRemoveList = (
  classId,
  mode = readRemoveAfterSelectionMode(classId),
  today = getTodayDateString()
) => {
  if (!classId) return [];
  const storage = getStorage();
  if (!storage) return [];
  return parseStoredNamesToRemoveList(
    storage.getItem(getNamesToRemoveListStorageKey(classId)),
    {
      expireAtMidnight: mode === REMOVE_AFTER_SELECTION_MODE.TODAY,
      today,
    }
  );
};

export const writeNamesToRemoveList = (
  classId,
  names,
  mode = readRemoveAfterSelectionMode(classId),
  enabled = true,
  today = getTodayDateString()
) => {
  if (!classId || !enabled) return;
  const storage = getStorage();
  if (!storage) return;
  const nextNames = Array.isArray(names) ? names : [];
  const payload = mode === REMOVE_AFTER_SELECTION_MODE.TODAY
    ? { date: today, names: nextNames }
    : { names: nextNames };
  storage.setItem(getNamesToRemoveListStorageKey(classId), JSON.stringify(payload));
};

export const clearNamesToRemoveList = (classId) => {
  if (!classId) return;
  const storage = getStorage();
  storage?.removeItem(getNamesToRemoveListStorageKey(classId));
};

export const clearRemoveAfterSelectionSessionState = () => {};
